import { createAction } from "redux-ts";

export const clearStore = createAction("STORE::CLEAR_STORE");